import React, { useEffect, useState } from 'react';
import { Head, Link } from '@inertiajs/inertia-react';

import Authenticated from '@/Layouts/Authenticated';

import Button from '@/Components/Button';
import numberFormat from '@/helpers/numberFormat';
import Select from 'react-select';
import ProductItem from '@/Components/Products/ProductItem';
import ProductsItemList from '@/Components/Products/ProductsItemList';
import axios from 'axios';
import { Inertia } from '@inertiajs/inertia';
import Swal from 'sweetalert2';
import Label from '@/Components/Label';
import { hasRole } from '@/helpers/user';
import classNames from 'classnames';


const Index = ({ products, branchOffices, flash, auth, ...props }) => {
    console.log({auth})
    const [branchOfficeIdFilter, setBranchOfficeIdFilter] = useState(hasRole(auth.user, 'super_admin') ? 'all' : auth.user.branch_office_id);

    const [branchOfficesFiltered, setBranchOfficesFiltered] = useState(hasRole(auth.user, 'super_admin') ? branchOffices : [branchOffices.find(branchOffice => branchOffice.id === branchOfficeIdFilter)]);
    const [productsStatusFilter, setProductsStatusFilter] = useState('active');

    const getProductsStatusLabel = (status) => {
        if (status === 'active') {
            return 'Activos'
        } else if (status === 'deleted') {
            return 'Eliminados'
        } else if (status === 'all') {
            return 'Todos'
        }

        return 'Todos';
    }

    useEffect(() => {
        if (branchOfficeIdFilter === 'all') {
            setBranchOfficesFiltered(branchOffices);
        } else {
            const branchOffice = branchOffices.find(branchOffice => branchOffice.id === branchOfficeIdFilter);
            setBranchOfficesFiltered([branchOffice]);
        }
    }, [branchOfficeIdFilter]);

    useEffect(() => {
        if (flash?.swal_no_branch_office) {
            const swalWithCustomButtons = Swal.mixin({
                buttonsStyling: false,
                customClass: {
                    cancelButton: 'mx-1 inline-flex items-center px-4 py-2 bg-gray-400 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150',
                    confirmButton: 'mx-1 inline-flex items-center px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150'
                },
                reverseButtons: true,
                showCancelButton: true,
            });

            swalWithCustomButtons.fire({
                icon: 'info',
                title: 'No tienes una sucursal creada',
                text: 'Los productos nuevos deben estar asociados a una sucursal. ¿Quieres crear una sucursal?',
                cancelButtonText: 'No, gracias',
                confirmButtonText: 'Crear una sucursal',
            }).then(({ isConfirmed }) => {
                if (isConfirmed) {
                    Inertia.get(route('branch-office.create'));
                }
            });
        }
    }, [])

    return (
        <Authenticated
            store={props.store}
            auth={auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Lista de productos</h2>}
        >
            <Head title="Lista de productos - Cerogrado" />
            <div className="max-w-7xl mx-auto w-full flex justify-between px-4 pt-8 mb-4">
                <div className="w-full flex items-center gap-4">
                    {hasRole(auth.user, 'super_admin') && (
                        <div className="relative w-full max-w-xs">
                            <Label className="absolute -top-5 left-0" value="Sucursales" />
                            <Select
                                styles={{
                                    indicatorSeparator: () => ({ display: "none" }),
                                    input: (styles) => ({
                                        ...styles,
                                        "> input": {
                                            boxShadow: "none !important",
                                        },
                                    }),
                                }}
                                className="w-full max-w-xs rounded-md shadow-none"
                                options={[
                                    {
                                        value: 'all',
                                        label: 'Todas',
                                    },
                                    ...branchOffices?.map(branchOffice => {
                                        return {
                                            value: branchOffice.id,
                                            label: branchOffice.name
                                        }
                                    })
                                ]}
                                value={
                                    branchOfficeIdFilter !== 'all' && Boolean(branchOffices.length)
                                        ? {
                                            value: branchOfficeIdFilter,
                                            label: branchOffices.find(({ id }) => id === branchOfficeIdFilter).name,
                                        }
                                        : {
                                            value: 'all',
                                            label: "Todas",
                                        }
                                }
                                noOptionsMessage={() =>
                                    "No hay sucursales disponibles"
                                }
                                onChange={({ value }) => setBranchOfficeIdFilter(value)}
                            />
                        </div>
                    )}
                    <div className="relative w-full max-w-xs">
                        <Label className="absolute -top-5 left-0" value="Productos" />
                        <Select
                            styles={{
                                indicatorSeparator: () => ({ display: "none" }),
                                input: (styles) => ({
                                    ...styles,
                                    "> input": {
                                        boxShadow: "none !important",
                                    },
                                }),
                            }}
                            className="w-full max-w-xs rounded-md shadow-none"
                            options={[
                                {
                                    value: 'active',
                                    label: getProductsStatusLabel('active'),
                                },
                                {
                                    value: 'deleted',
                                    label: getProductsStatusLabel('deleted'),
                                },
                                {
                                    value: 'all',
                                    label: getProductsStatusLabel('all'),
                                },
                            ]}
                            value={{
                                value: productsStatusFilter,
                                label: getProductsStatusLabel(productsStatusFilter),
                            }}
                            noOptionsMessage={() =>
                                "No hay sucursales disponibles"
                            }
                            onChange={({ value }) => setProductsStatusFilter(value)}
                        />
                    </div>
                </div>
                <Link href={route('products.create')}>
                    <Button className="whitespace-nowrap" type="button">Crear un producto</Button>
                </Link>
            </div>
            <div className="grid grid-cols-1 gap-8 max-w-7xl w-full px-4 mx-auto">
                {branchOfficesFiltered.map(branchOffice => (() => {
                    const filteredProducts = products
                        .filter(product => product.branch_office_id === branchOffice.id)
                        .filter(product => productsStatusFilter === 'all' || (productsStatusFilter === 'active' && !product.deleted_at) || (productsStatusFilter === 'deleted' && product.deleted_at))

                    return (
                        <div className={classNames({
                            "bg-white rounded-xl p-4": filteredProducts.length === 0
                        })} key={`branch-office-list-${branchOffice.id}`}>
                            <h2 className="mb-2 text-gray-600 text-2xl">{branchOffice.name}</h2>

                            <ProductsItemList
                                products={filteredProducts}
                                noProductsMessage={<>La sucursal <strong>"{branchOffice.name}"</strong> no tiene {productsStatusFilter !== 'all' ? `productos ${getProductsStatusLabel(productsStatusFilter).toLowerCase()}` : 'productos' }.</>}
                            />
                        </div>
                    )
                })())}
            </div>
        </Authenticated>
    )
}

export default Index;
